import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';

const Title = styled(DialogTitle)(({ theme }) => ({
  color:
    theme.palette.mode === 'dark' ? theme.palette.dashboard.dark.text : theme.palette.text.primary,
  '& .MuiTypography-h6': {
    fontWeight: '600',
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.dashboard.dark.text
        : theme.palette.text.primary,
  },
}));

const DialogContentText = styled('div')(({ theme }) => ({
  paddingTop: '0',
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.dashboard.dark.textMuted
      : theme.palette.text.primary,
  '& .MuiTypography-root': {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.dashboard.dark.textMuted
        : theme.palette.text.primary,
  },
}));

export { Title, DialogContentText };
